import { render, staticRenderFns } from "./BrowseByBrand.vue?vue&type=template&id=e70c8c1e&scoped=true&"
import script from "./BrowseByBrand.vue?vue&type=script&lang=js&"
export * from "./BrowseByBrand.vue?vue&type=script&lang=js&"
import style0 from "./BrowseByBrand.vue?vue&type=style&index=0&id=e70c8c1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70c8c1e",
  null
  
)

export default component.exports